/** Standardized onboarding screen identifiers — routing reference only */

export const SCREENS = {

  ELT01: 'Screen-ELT01',

  ELT02: 'Screen-ELT02',

  ELT03: 'Screen-ELT03',

  ELT04: 'Screen-ELT04',

  ELT05: 'Screen-ELT05',

  ELT06: 'Screen-ELT06',

  ELT07: 'Screen-ELT07',

  ELT08: 'Screen-ELT08',

  ELT09: 'Screen-ELT09',

  ELT10: 'Screen-ELT10',

  PRO01: 'Screen-PRO01',

  PRO02: 'Screen-PRO02',

  PRO03: 'Screen-PRO03',

  PRO04: 'Screen-PRO04',

  PRO08: 'Screen-PRO08',

  PRO08X: 'Screen-PRO08X',

} as const;



/**

 * Screen-PRO01 — Registration Key Entrance only (`/portal-login`).

 * Private mentee Stripe signup is Screen-PRO03 (`/register-private`).

 */

export const PRO01_ROUTES = {

  PORTAL_LOGIN: '/portal-login',

} as const;



export function isPro01PortalLoginRoute(pathname: string): boolean {

  return pathname === PRO01_ROUTES.PORTAL_LOGIN;

}



export const SCREEN_ROUTES = {

  [SCREENS.ELT01]: '/',

  [SCREENS.ELT02]: '/register-select',

  [SCREENS.ELT03]: '/register-code',

  [SCREENS.ELT04]: '/introduction',

  [SCREENS.ELT05]: '/introduction',

  [SCREENS.ELT06]: '/system-admin',

  [SCREENS.ELT07]: '/register-org',

  [SCREENS.ELT08]: '/mentor-console',

  [SCREENS.ELT09]: '/corporate-lounge',

  [SCREENS.ELT10]: '/elt-setup',

  [SCREENS.PRO01]: PRO01_ROUTES.PORTAL_LOGIN,

  [SCREENS.PRO02]: '/register-mentee-code',

  [SCREENS.PRO03]: '/register-private',

  [SCREENS.PRO04]: '/pro-setup',

  [SCREENS.PRO08]: '/mentee-lounge',

  [SCREENS.PRO08X]: '/stress-test',

} as const;



export const REGISTRATION_PATHWAY = {

  INVITATION: 'A',

  ORGANISATION: 'B',

  INDIVIDUAL: 'C',

  FREE_TRIAL: '2',

  /** Corporate procurement provisional demo (ELTDXXX) — Screen-ELT07 Pathway B. */

  PROCUREMENT: 'PO',

} as const;



export const CLIENT_KEY_STORAGE = 'mentology.orgClientKey';

export const MENTEE_KEY_STORAGE = 'mentology.menteeClientKey';

export const MENTEE_ENTRY_GATE_STORAGE = 'mentology.menteeEntryGate';

export const REGISTRATION_PATHWAY_STORAGE = 'mentology.registrationPathway';



export {

  normalizeKey,

  normalizeKey as normalizeClientKey,

  isDemoCreationCode,

  isDemoAccessKey,

  isPaidSubscriptionKey,

  isPaidProKey,

  isPaidOrgKey,

  isOrgMenteeKey,

  isPortalLoginKey,

  isPortalEntranceKey,

  isMentorActivationKey,

  isProcurementDemoKey,

  isProBriefingKey,

  isEltBriefingKey,

  mintDemoCreationCode,

  demoCreationTrack,

  orgCodeFromCompanyName,

  REGEX,

  KEY_TYPES,

} from './keyRegistry';



import {

  normalizeKey,

  isDemoAccessKey,

  isPaidOrgKey,

  isOrgMenteeKey,

  isProcurementDemoKey,

  isProBriefingKey,

} from './keyRegistry';



export function resolveGrandFoyerRoute(storedKey: string, registrationPathway: string | null) {

  const key = normalizeKey(storedKey);

  const entryGate = sessionStorage.getItem(MENTEE_ENTRY_GATE_STORAGE);



  if (isProcurementDemoKey(key) || registrationPathway === REGISTRATION_PATHWAY.PROCUREMENT) {

    return { label: '[ Enter Admin Console ]', route: '/org-admin' };

  }



  if (registrationPathway === REGISTRATION_PATHWAY.ORGANISATION) {

    return { label: 'Enter Mentoring Admin Console', route: '/org-admin' };

  }



  if (registrationPathway === REGISTRATION_PATHWAY.INVITATION && isDemoAccessKey(key) && key.startsWith('PRO')) {

    return { label: 'Enter Briefing Room', route: '/pro-setup' };

  }



  if (registrationPathway === REGISTRATION_PATHWAY.INVITATION && isPaidOrgKey(key) && entryGate !== 'portal') {

    return { label: 'Enter Mentoring Admin Console', route: '/org-admin' };

  }



  if (entryGate === 'portal' && (isOrgMenteeKey(key) || (isDemoAccessKey(key) && key.startsWith('ELT')))) {

    return { label: 'Continue to Setup', route: '/elt-setup' };

  }



  if (isProBriefingKey(key)) {

    return { label: 'Enter Briefing Room', route: '/pro-setup' };

  }



  if (isOrgMenteeKey(key) || (isDemoAccessKey(key) && key.startsWith('ELT'))) {

    return { label: 'Continue to Setup', route: '/elt-setup' };

  }



  if (isPaidOrgKey(key)) {

    return { label: 'Enter Mentoring Admin Console', route: '/org-admin' };

  }



  return null;

}



export function resolveWorkspaceScreenId(role?: string) {

  return role === 'ELT' ? SCREENS.ELT09 : SCREENS.PRO08;

}

